import { createAuthBearerToken } from './createAuthBearerToken'

export function createAuthHeaders(token: string): Record<string, string>
// eslint-disable-next-line @typescript-eslint/ban-types
export function createAuthHeaders(token: null | undefined): {}
export function createAuthHeaders(token: string | null | undefined) {
  return token ? { Authorization: createAuthBearerToken(token) } : {}
}
